import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "./../axiosMethodCalls";
const user = getUser();
const token = getToken();

//GET
export const getCustomer = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "customers/get",
            {
                requester: user,
                token: token,
                customer_id: data.id,
                trade_name: data.trade_name,
                page: data.page,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const createCustomer = async (info) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("bir_name", info.bir_name ? info.bir_name : "");
    form_data.append("trade_name", info.trade_name ? info.trade_name : "");
    form_data.append("bir_address", info.bir_address ? info.bir_address : "");
    form_data.append("trade_address", info.trade_address ? info.trade_address : "");
    form_data.append("tin", info.tin ? info.tin : "");
    form_data.append("terms", info.terms ? info.terms : "");
    form_data.append("email", info.email ? info.email : "");
    form_data.append("contact_person", info.contact_person ? info.contact_person : "");
    form_data.append("credit_limit", info.credit_limit ? info.credit_limit : "");
    form_data.append("vat_type", info.vat_type ? info.vat_type : "");
    form_data.append("withholding_percentage", info.withholding_percentage ? info.withholding_percentage : "");
    form_data.append("phone_no", info.phone_no ? info.phone_no : "");
    form_data.append("payee", info.payee ? info.payee : "");
    // form_data.append("attachments[]", file ? file : "");

    info.attachments.map((file) => {
        form_data.append(`attachments[]`, file, file.name);
    })

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "customers/create",
            form_data
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateCustomer = async (info) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("customer_id", info.id);
    form_data.append("bir_name", info.bir_name ? info.bir_name : "");
    form_data.append("trade_name", info.trade_name ? info.trade_name : "");
    form_data.append("bir_address", info.bir_address ? info.bir_address : "");
    form_data.append("trade_address", info.trade_address ? info.trade_address : "");
    form_data.append("tin", info.tin ? info.tin : "");
    form_data.append("terms", info.terms ? info.terms : "");
    form_data.append("email", info.email ? info.email : "");
    form_data.append("contact_person", info.contact_person ? info.contact_person : "");
    form_data.append("credit_limit", info.credit_limit ? info.credit_limit : "");
    form_data.append("vat_type", info.vat_type ? info.vat_type : "");
    form_data.append("withholding_percentage", info.withholding_percentage ? info.withholding_percentage : "");
    form_data.append("phone_no", info.phone_no ? info.phone_no : "");
    form_data.append("payee", info.payee ? info.payee : "");
    // form_data.append("attachments[]", file ? file : "");

    info.attachments.map((file) => {
        form_data.append('attachments[]', file, file.name);
        form_data.append('attachment_ids[]', null);
    });
    info.prev_files.map((file) => {
        form_data.append('attachment_ids[]', file.id);
    });

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "customers/update",
            form_data
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const deleteCustomer = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "customers/delete",
            {
                requester: user,
                token: token,
                customer_id: id,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};